import BaseUploadButton from './BaseUploadButton'
import ImageUpload from './ImageUpload'
import ImageUploader from './ImageUploader'
import PhotosUpload from './PhotosUpload'

interface IUploadButton {
  ImageUploader: typeof ImageUploader
  ImageUpload: typeof ImageUpload
  PhotosUpload: typeof PhotosUpload
}

const UploadButton: IUploadButton = {
  ImageUploader,
  ImageUpload,
  PhotosUpload,
}

export default Object.assign(BaseUploadButton, UploadButton)
